<template>
  <modal class="invoice-success-modal">
    <balloon-cloud />
    <h2 class="font-bold"> Factuur verstuurd! </h2>
    <p> Je factuur is verstuurd naar de zorginstelling.</p>
  </modal>
</template>

<script lang="ts" setup>
import Modal from '@app/components/Modal.vue';
import BalloonCloud from '@app/illustrations/BalloonCloud.vue';

</script>

<style lang="scss">

  .pidz-illustration {
    max-width: 400px;
    margin: auto;
    display: block;

}

</style>
